import type { CSSProperties } from "react";

export const readOnlyStyle: CSSProperties = {
  opacity: 0.35,
  pointerEvents: "none",
};
